import type { RouteRecordRaw } from 'vue-router';
export const wmsRoutes: RouteRecordRaw[] = [
  {
    path: 'wms',
    name: 'wms',
    component: () => import('../pages/wms/WmsPage.vue'),
    meta: { requiresModule: 'wms' },
  },
];
